import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { Text } from 'atoms';

export default function ConfimationBeforeSubmit({ visible, handleOk, handleCancel, unblock }) {
	console.log(unblock);
	const [isDisabled, setIsDisabled] = useState(unblock);

	// Reset `isDisabled` state when `visible` changes
	useEffect(() => {
		if (visible) {
			setIsDisabled(unblock);
		}
	}, [visible, unblock]);

	const handleYesClick = async () => {
		setIsDisabled(true); // Disable the button
		try {
			await handleOk(); // Call the `handleOk` function (assume it can be asynchronous)
		} catch (error) {
			console.error(error);
			setIsDisabled(false); // Re-enable the button if an error occurs
		}
	};

	return (
		<Modal
			title={
				<Text textAlign="center" fontSize="14px" padding="0 15px">
					Submit Confirmation
				</Text>
			}
			footer={null}
			visible={visible}
			onCancel={handleCancel}
			width={300}
		>
			<Text
				textAlign="center"
				fontSize="14px"
				style={{ fontWeight: '600', marginTop: '5px' }}
			>
				Are you sure you want to submit collections?
			</Text>
			<div style={{ marginTop: '33px', textAlign: 'right', padding: '10px 16px' }}>
				<button type="button" className="ant-btn ant-btn-default" onClick={handleCancel}>
					<span>No</span>
				</button>
				<button
					style={{ marginLeft: '10px' }}
					type="button"
					className="ant-btn ant-btn-primary"
					onClick={handleYesClick}
					disabled={isDisabled} // Disable the button conditionally
				>
					<span>Yes</span>
				</button>
			</div>
		</Modal>
	);
}

ConfimationBeforeSubmit.propTypes = {
	visible: PropTypes.bool.isRequired,
	handleOk: PropTypes.func.isRequired,
	handleCancel: PropTypes.func.isRequired,
	unblock: PropTypes.bool,
};
